import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { CartService } from '@b2b/core/api/cart/cart.service';

import { SnackbarService } from '@sparro/app/core/helpers/toastr/snackbar.service';

import { environment } from '@b2b/env/environment';
import { User } from '@sparro/app/core/models/user.model';

@Component({
  selector: 'app-cart-dialog',
  templateUrl: './cart-dialog.component.html',
  styleUrls: ['./cart-dialog.component.scss']
})

export class CartDialogComponent implements OnInit {
  cart: any;
  products: any;
  response: any;
  studentInfoArray: string[] = [];
  professionalInfoArray: string[] = [];
  institutionalInfoArray: string[] = [];

  compSlug: string;
  selectedProduct: string;

  cart_exists: boolean = false;
  isLoading: boolean = false;
  isProcessing: boolean = false;
  hasMembership: boolean = false;
  institutionSelected: boolean = false;
  empty_cart: boolean = true;
  userInfoView: boolean = false;

  user: User;

  userInfoForm: FormGroup = new FormGroup({
    name: new FormControl('', [Validators.required]),
    email: new FormControl('', [Validators.email, Validators.required]),
    experience: new FormControl('', [Validators.required, Validators.min(0)])
  });

  private serverUrl: string;
  private loginUrl: string;

  constructor(
    public dialogRef: MatDialogRef<CartDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private cartService: CartService,
    private snackbarService: SnackbarService,
    private changeDetectorRef: ChangeDetectorRef,
  ) {
    this.serverUrl = `${environment.serverUrl}`;
    this.loginUrl = `${environment.loginUrl}`;
  }

  ngOnInit() {
    this.initializeCart();
    this.compSlug = this.data.comp_slug;
    this.user = this.data.user;
    this.hasMembership = this.data.hasMembership;
    if (this.compSlug) {
      this.showProducts(this.compSlug);
    }
    this.initiateInfoArray();
  }

  get formControls() {
    return this.userInfoForm.controls;
  }


  ngAfterViewChecked() {
    this.changeDetectorRef.detectChanges();
  }

  initiateInfoArray() {
    this.studentInfoArray = [
      '- For individual or group entry (refer brief for members limit)',
      '- All team members must be students at the time of the registration',
      '- The group can have a mentor as an additional member. Only a teaching faculty in college will qualify as a mentor'
    ];
    this.professionalInfoArray = [
      '- For individual or group entry (refer brief for members limit)',
      '- Teams can consist of all professionals or a mix of students and professionals'
    ];
    this.institutionalInfoArray = [
      '- For students only. Professionals are not allowed',
      '- Max 20 students allowed who can take part individually or in groups (refer brief for members limit)',
      '- All students must be of same college or university',
      '- Entries must have a teaching faculty from same institute as a mentor'
    ];
  }

  saveUserDetail() {
    if (!this.userInfoForm.valid) {
      return;
    }

    this.userInfoView = false;
  }

  // getAuthUser() {
  //   this.authService.getAuthUser().subscribe(
  //     (user: User) => {
  //       this.user = user;
  //     },
  //     (err) => {
  //       console.log(err);
  //     });
  // }

  // checkCart() {
  //   this.cart_exists = this.cookieService.check('cart_uuid');
  //   if (this.cart_exists) {
  //     console.log("cart exists");
  //     this.viewCart();
  //   } else {
  //     console.log("cart not exists");
  //     this.initializeCart();
  //   }
  // }

  onNoClick(): void {
    this.dialogRef.close();
  }

  // Fetches Product list and forwards control to checkCart
  showProducts(comp_slug: string) {
    this.cartService.showProducts(comp_slug).subscribe(
      (data) => {
        this.response = data;
        // console.log(this.response, "Data");
        this.products = [];
        this.response.map((category, index) => {
          category.product.student = category.category_type == 'STUDENT' ? true : false;
          category.product.professional = category.category_type == 'PROFESSIONAL' ? true : false;
          category.product.institutional = category.category_type == 'INSTITUTION' ? true : false;
          this.products.push(category.product);
        });
        this.selectedProduct = this.products[0].uuid;
        // this.checkCart();
      },
      (err) => {
        console.log(err);
      });
  }

  // viewCart() {
  //   const cart_uuid = this.cookieService.get('cart_uuid');
  //   this.cartService.viewCart(cart_uuid).subscribe(
  //     (response) => {
  //       this.cart = response;
  //       this.mapItemsToProducts();
  //     },
  //     (error) => {
  //       console.log(error);
  //     });
  // }

  // Initializes cart and sets cart_uuid
  initializeCart() {
    this.cartService.getCart().subscribe(
      (response: any) => {
        this.cart = response;
        // console.log(response)
        this.mapItemsToProducts();
      },
      (err) => {
        console.log(err);
      });
  }

  getSelectedProduct(event) {
    // console.log(event)
    if (event.value.institutional) {
      this.institutionSelected = true;
    } else {
      this.institutionSelected = false;
    }
    this.selectedProduct = event.value.uuid;
    this.changeDetectorRef.detectChanges();
  }

  onClickRegister() {
    if (this.user) {
      if (this.hasMembership && !this.institutionSelected) {
        this.createMembershipPayment();
      } else {
        this.addItemToCart();
      }
    } else {
      this.getLoginUrl();
    }
  }

  addItemToCart() {
    this.isProcessing = true;
    const data = {
      product: this.selectedProduct,
      quantity: 1,
    };

    this.cartService.addToCart(this.cart.uuid, data).subscribe(
      (response: any) => {
        this.cart = response;
        this.goToPayments();
        this.isProcessing = false;
      },
      (err) => {
        console.log(err);
        this.snackbarService.error('Product could not be added to cart.');
        this.isProcessing = false;
      });
  }


  createMembershipPayment() {
    this.isProcessing = true;
    const payment_details = {
      transaction: this.cart.uuid,
      product_uuid: this.selectedProduct
    };
    // console.log(payment_details);
    this.cartService.membershipPayment(payment_details).subscribe(
      (response: any) => {
        this.isProcessing = false;
        window.location.href = `${this.serverUrl}/payment/transaction/history/${response.uuid}`;
      },
      (err) => {
        console.log(err);
        this.isProcessing = false;
      });
  }

  mapItemsToProducts() {
    this.empty_cart = true;
    this.cart.items.map(
      (item, index) => {
        this.products.map(
          (product, index_2) => {
            if (item.product.uuid === product.uuid) {
              // console.log(item, 'item');
              product.item = item;
              // console.log(product, 'product');
              this.empty_cart = false;
            }
          });
      });
  }

  // increaseItemQuantity(item) {
  //   this.isLoading = true;
  //   const data = {
  //     product: item.product.uuid,
  //     quantity: item.quantity + 1,
  //   }
  //   this.cartService.updateItem(this.cart.uuid, item.id, data).subscribe(
  //     (response) => {
  //       this.cart = response;
  //       this.mapItemsToProducts();
  //       this.isLoading = false;
  //       this.toastr.success("Item quantity increased successfully");
  //     }, (error) => {
  //       this.toastr.error("Item quantity could not be increased.");
  //     }
  //   );
  // }

  // decreaseItemQuantity(item) {
  //   this.isLoading = true;
  //   if (item.quantity == 1) {
  //     // alert('Are you sure you want to remove?'); // TODO: confirmation pop up
  //     this.removeItem(item);
  //     this.isLoading = false;
  //   }
  //   const data = {
  //     product: item.product.uuid,
  //     quantity: item.quantity - 1,
  //   }
  //   this.cartService.updateItem(this.cart.uuid, item.id, data).subscribe(
  //     (response) => {
  //       this.cart = response;
  //       this.mapItemsToProducts();
  //       this.isLoading = false;
  //       // this.toastr.success("Item quantity decreased successfully");
  //     }, (error) => {
  //       this.toastr.error("Item quantity could not be decreased.");
  //     }
  //   );
  // }

  // removeItem(item) {
  //   this.products.map(
  //     (product, index) => {
  //       if (product.item) {
  //         if (product.item.id === item.id) {
  //           product.item = null;
  //         }
  //       }
  //     });
  // }

  goToPayments() {
    window.location.href = `${environment.paymentUrl}`;
  }

  getLoginUrl() {
    window.location.href = `${this.loginUrl}/authentication?service=sign-in&continue=${window.location.href}`;
  }

  goToForm() {
    window.open('https://pages.razorpay.com/pl_MsRJ8vY4DUGUGu/view', '_blank');
    this.dialogRef.close();
  }

  showSubscriptionToast(item) {
    // this.toastr.info("Are you looking to register more entries. Subscribe to UNI competition bundle now and save big on registration fees. Learn more")
    //   .onTap
    //   .pipe(take(1))
    //   .subscribe(() => this.subscriptionToastHandler());
  }

  subscriptionToastHandler() {
    window.open('http://about.uni.xyz/subscription.html', '_blank');
    // console.log('Toast clicked. Open Subscription page in new tab')
  }
}
